import { FRACTIONS } from '@/utils/constants/drs/fractions'

const DEVICES = {
    Aplikacja: {
        image: require('@/assets/img/drs/application-device.svg'),
        tooltip: 'Aplikacja mobilna'
    },
    Kasa: {
        image: require('@/assets/img/drs/cash-device.svg'),
        tooltip: 'Kasa'
    },
    RVM: {
        image: require('@/assets/img/drs/rvm-device.svg'),
        tooltip: 'RVM'
    },
    Panel: {
        image: require('@/assets/img/drs/panel-device.svg'),
        tooltip: 'Panel EuroPlatform'
    }
}

export default {
    computed: {
        bags() {
            const list = []
            const fractions = this.handover?.fractions || []

            // One seal_number is one bag, but bag may be listed in several fractions
            for (const fraction of fractions) {
                const matchedFraction = Object.values(FRACTIONS).find(item => item.id === fraction.id)

                for (const bag of fraction.bags || []) {
                    const existing = bag.seal_number && list.find(item => item.sealNumber === bag.seal_number)

                    if (!existing) {
                        list.push({
                            sealNumber: bag.seal_number || null,
                            closedDate: bag.closed_date || null,
                            value: bag.value || 0,
                            name: matchedFraction?.name || fraction.name,
                            type: matchedFraction?.type || null
                        })
                        continue
                    }

                    existing.value += bag.value || 0
                    existing.closedDate = existing.closedDate || bag.closed_date || null
                    existing.name = FRACTIONS.mix.name
                    existing.type = FRACTIONS.mix.type
                }
            }

            return {
                count: list.length,
                value: list.reduce((sum, item) => sum + item.value, 0),
                list
            }
        },

        bagsCount() {
            return `${this.bags.count} szt`
        },

        issuedAt() {
            const date = this.handover?.handover_date
            if (!date) {
                return { date: '—--', time: '---' }
            }

            const moment = this.$moment(date)

            return {
                date: moment.format('DD-MM-YYYY'),
                time: moment.format('HH:mm')
            }
        },

        operatorName() {
            return this.handover?.receiver?.name || '—--'
        },

        issuedBy() {
            const handover = this.handover || {}
            const cashier = handover.cashier || ''
            const device = handover.device || {}
            // An email cashier was issued from the EuroPlatform panel, not from device.device_type
            const email = typeof cashier === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(cashier.trim())
            const known = DEVICES[email ? 'Panel' : device.device_type]

            let value = cashier || '—--'
            if (!email && device.alias) {
                value = cashier ? `${cashier} ${device.alias}` : device.alias
            }

            return {
                deviceImage: known?.image || null,
                deviceName: known?.tooltip || device.device_type,
                value
            }
        }
    },

    methods: {
        valueToCurrency(value) {
            return this.$options.filters.currency((value || 0) / 100)
        }
    }
}
